export type MentionPerson={id:string;name:string};
const quote=(value:string)=>value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
export function mentionRanges(body:string,names:string[]){
  const ranges:{start:number;end:number}[]=[];
  for(const name of [...new Set(names)].filter(Boolean).sort((a,b)=>b.length-a.length)){
    const pattern=new RegExp(`(^|\\s)@${quote(name)}(?=$|[\\s.,!?;:])`,'giu');
    for(const match of body.matchAll(pattern)){
      const start=match.index!+match[1].length,end=match.index!+match[0].length;
      if(!ranges.some(r=>start<r.end&&end>r.start))ranges.push({start,end});
    }
  }
  return ranges.sort((a,b)=>a.start-b.start);
}
export function mentionedIds(body:string,people:MentionPerson[],chosen:string[]=[]){
  const chosenSet=new Set(chosen);
  const labels=mentionRanges(body,people.map(p=>p.name)).map(r=>body.slice(r.start+1,r.end).toLocaleLowerCase());
  return people.filter(p=>labels.includes(p.name.toLocaleLowerCase())&&(chosenSet.has(p.id)||(!people.some(q=>q.id!==p.id&&q.name.toLocaleLowerCase()===p.name.toLocaleLowerCase())))).map(p=>p.id);
}
